import { Link } from 'react-router-dom';
import { categories } from '@/mocks/games';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-200">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-gamepad-line text-lg text-background-50"></i>
              </span>
              <span className="text-lg font-heading font-bold text-background-50">
                工口游戏攻略
              </span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed">
              最全面的中文工口游戏资讯平台，提供游戏推荐、玩法攻略、新作速递与下载指引，助你发现每一款值得体验的佳作。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-bold text-background-50 mb-4">
              游戏分类
            </h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 4).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-background-50 mb-4">
              更多分类
            </h4>
            <ul className="space-y-2.5">
              {categories.slice(4).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-background-50 mb-4">
              关于本站
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link
                  to="/about"
                  className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                >
                  关于我们
                </Link>
              </li>
              <li>
                <a
                  href="/about#contact"
                  className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                >
                  联系我们
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-800/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; 2025 工口游戏攻略大全. All rights reserved.
          </p>
          <p className="text-xs text-background-600">
            本站内容仅供18岁以上用户浏览
          </p>
        </div>
      </div>
    </footer>
  );
}